{
  "id": "night-five",
  "label": "Nattens fem",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "planning": {
    "titlePattern": "Till red: Nattens fem viktigaste nyheter",
    "slugline": "tillred"
  },
  "sources": [
    { "type": "article", "newsvalues": [] }
  ],
  "postamble": ["Mer info på TT:s morgon-pm klockan 07."],
  "blocks": [
    {
      "id": "top-news",
      "label": "Nattens fem",
      "preamble": [],
      "grouping": "none",
      "item": {
        "headline": "{headline} – {section}",
        "lines": []
      }
    }
  ]
}
